'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const LogoDecathlonCoreSymbolWhiteAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.1696 2.28882e-06C11.7888 2.28882e-06 0.119934 9.70597 0.119934 17.7501C0.119934 21.9047 3.3111 24 7.52586 24C10.6207 24 14.3658 22.868 17.9784 20.6884V4.63623C17.0151 6.286 12.4872 12.9333 8.85049 16.4737C6.996 18.28 5.52685 19.0627 4.26243 19.0627C2.84145 19.0627 2.1671 18.0993 2.1671 16.6663C2.1671 10.1636 13.1134 1.70999 20.3628 1.70999C23.3492 1.70999 25.276 3.03462 25.276 5.61164C25.276 7.9719 23.6744 10.9343 20.9408 13.6678V18.6412C25.7095 14.8721 28.5635 10.0672 28.5635 6.18966C28.5635 2.10737 25.3844 2.28882e-06 21.1696 2.28882e-06Z",
        fill: "white"
      }
    )
  }
);
const VpLogoDecathlonCoreSymbolWhiteAsset = forwardRef(LogoDecathlonCoreSymbolWhiteAsset);

export { VpLogoDecathlonCoreSymbolWhiteAsset as default };
